import { humanLowerCaseToId } from '~/misc/equipment';

export const platformParser = (ua = window.navigator.userAgent) =>  {
  if(/(iPhone|iPad|iPod|iOS)/i.test(ua)) return "Ios";
  if(/(Android|Adr)/i.test(ua)) return "Android";
  return "Pc";
};

const ObjectToQuery = (obj) => {
  const query = Object.entries(obj).filter(([key,value])=> value&&value.length).reduce((acc,cur)=>{
    const [key,value] = cur;
    return `${acc}${key}=${value}&`
  },'?')
  return query.substring(0, query.length-1)
}

const timeParser = ({ start, end }) => { 
  let [fromTime , toTime] = [start, end].map(e=>new Date(e));
  let timeArr = [];
  let nowDay = fromTime;
  timeArr.push(`${nowDay.getFullYear()}-${nowDay.getMonth()+1}-${nowDay.getDate()}`);
  while(nowDay.getTime()<toTime.getTime()){
    nowDay.setDate(nowDay.getDate()+1);
    timeArr.push(`${nowDay.getFullYear()}-${nowDay.getMonth()+1}-${nowDay.getDate()}`);
  }
  return timeArr;
}

const arrToqueryString = (arr,queryname) => {
  if (arr.length === 0) return ''
  return arr.reduce((acc,cur)=>{
    return acc+'&'+queryname+'='+cur
  },'')
}

const weightMap = {
  'any': {
    min: "-1",
    max: "-1"
  }, 
  'min': {
    min:"-1",
    max: 26000,
  },
  "upperMin": { 
    min: 26001,
    max: 33000,
  },
  "middle": {
    min: 33001,
    max: 40000,
  },
  "max": { 
    min: 40001,
    max: "-1"
  }
}

export const mobileSearchBuiler = ({
  type,
  pickUpDate,
  dropOffDate,
  pickLat,
  pickLng,
  pickCity,
  pickState,
  pickDeadHead,
  dropLat,
  dropLng,
  dropCity,
  dropState,
  dropDeadHead,
  loadSize,
  weight, // min/upperMin/middle/max
  length,
}) => {
  const { min, max } = weight ? weightMap[weight] : weightMap['any']
  const queryObj = {
    type,
    pickUpDate,
    dropOffDate,
    pickLat,
    pickLng,
    pickAddress: `${pickCity},_${pickState}`,
    pickDeadHead,
    dropLat,
    dropLng,
    dropAddress: `${dropCity},_${dropState}`,
    dropDeadHead,
    tripLength: 'any',
    loadSize,
    weight_Min: min,
    weight_Max: max,
    weight_null: true,
    length,
    length_null: true,
    sort: "Time_Posted_Newest_first"
  }
  return ObjectToQuery(queryObj);
} 

export const  webSearchBuilder = ({
  types,
  pickUpDate,
  dropOffDate,
  pickLat,
  pickLng,
  pickCity,
  pickState,
  pickDeadHead,
  dropLat,
  dropLng,
  dropCity,
  dropState,
  dropDeadHead,
  loadSize,
  weight,
  length,
}) => {
  const query = {
    dhd: dropDeadHead,
    dho: pickDeadHead,
    emptyLength: true,
    emptyWeight: true,
    from_city: pickCity,
    from_country: 'US',
    from_lat: pickLat,
    from_lng: pickLng,
    from_name: `${pickCity}, ${pickState}`,
    from_state: pickState,
    limit: 50,
    loadSize,
    offset: "0",
    show_option: "All",
    sort_by: "age",
    sort_order: "asc",
    to_city: dropCity,
    to_country: 'US',
    to_lat: dropLat,
    to_lng:dropLng,
    to_name: `${dropCity}, ${dropState}`,
    to_state: dropState,
    weight,
    length,
  }
  const dateQuery = arrToqueryString(timeParser({
    start:pickUpDate,
    end: dropOffDate,
  }), "date")
  const equipmentQuery =
    types && types.length
      ? arrToqueryString(
          types.split(",").map((e) => humanLowerCaseToId[e]),
          "equipment"
        )
      : "";
  return ObjectToQuery(query) + `${dateQuery}` + `${equipmentQuery}`
}


// WEBPACK FOOTER //
// ./src/pages/EmailCampaign/uilts.js